export function rotuloLiberarSelecionadas(quantidade: number): string {
  if (quantidade === 0) return 'Liberar selecionadas';
  return `Liberar selecionadas (${quantidade})`;
}

export function mensagemFalhaLiberar(quantidade: number): string {
  return `Não foi possível liberar ${quantidade} OP(s). Tente novamente.`;
}

import type { KanbanAviso } from '@pieltec/contracts';
import { rotuloUnidade } from './unidade';

export function formatarAviso(aviso: KanbanAviso): string {
  switch (aviso.codigo) {
    case 'WIP_CELULA_EXCEDIDO':
      if (aviso.detalhe?.ocupado != null && aviso.detalhe?.limite != null) {
        const ocupado = Number(aviso.detalhe.ocupado);
        const limite = Number(aviso.detalhe.limite);
        if (Number.isFinite(ocupado) && Number.isFinite(limite)) {
          return `WIP da célula destino: ${ocupado}/${limite} ${rotuloUnidade(aviso.detalhe.unidade)}`;
        }
      }
      return aviso.mensagem;
    case 'PRAZO_ESTOURADO':
      return 'prazo estourado';
    case 'PRAZO_PERTO':
      return 'prazo perto';
    case 'ATRIBUTOS_INCOMPLETOS':
      return aviso.mensagem.trim() || 'Revise os atributos de pintura em Cadastros → Peças / Produtos → Dados técnicos';
    case 'FALTA_MATERIAL':
      return aviso.mensagem;
    case 'MATERIAIS_A_DEFINIR':
      return aviso.mensagem;
    default:
      return aviso.mensagem;
  }
}

export function mensagemLiberarComAvisos(avisos: KanbanAviso[]): string {
  const formatados = avisos.map(formatarAviso).join('; ');
  return `Atenção: ${formatados}. Liberar mesmo assim?`;
}

export function selecaoAposFalhas(selecionados: string[], falhas: { opId: string; motivo: string }[]): string[] {
  const falhouIds = new Set(falhas.map((f) => f.opId));
  return selecionados.filter((id) => falhouIds.has(id));
}

export function validarMotivo(input: { tipoInterrupcaoId?: string; outro?: string }): string | null {
  const temLista = Boolean(input.tipoInterrupcaoId && input.tipoInterrupcaoId !== 'OUTRO');
  const temOutro = Boolean(input.outro && input.outro.trim().length > 0);

  if (input.tipoInterrupcaoId === 'OUTRO') {
    if (!temOutro) return 'Descreva o motivo (obrigatório)';
    return null;
  }

  if (temLista && temOutro) return 'Escolha um motivo da lista ou Outro, não os dois';
  if (!temLista && !temOutro) {
    if (input.outro !== undefined && !temOutro) return 'Descreva o motivo (obrigatório)';
    return 'Selecione um motivo';
  }
  return null;
}

export function montarCorpoBloqueio(input: { tipoInterrupcaoId?: string; outro?: string }, versao: number): { tipoInterrupcaoId?: string; motivoOutro?: string; versao: number } {
  if (input.tipoInterrupcaoId === 'OUTRO') {
    return { motivoOutro: input.outro?.trim(), versao };
  }
  return { tipoInterrupcaoId: input.tipoInterrupcaoId, versao };
}
